import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceUtilizationHeatmap = ({ data }) => {
  const getUtilizationColor = (value) => {
    if (value >= 90) return 'bg-error text-white';
    if (value >= 75) return 'bg-warning text-gray-900';
    if (value >= 50) return 'bg-success/70 text-white';
    return 'bg-muted text-foreground';
  };

  const getUtilizationLabel = (value) => {
    if (value >= 90) return 'Critical';
    if (value >= 75) return 'High';
    if (value >= 50) return 'Moderate';
    return 'Low';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-semibold text-foreground">Service Utilization Heatmap</h2>
          <p className="text-sm text-muted-foreground mt-1">Hourly capacity utilization by department</p>
        </div>
        <Icon name="Activity" size={24} color="var(--color-primary)" />
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[600px]">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-semibold text-foreground">Department</th>
              {data?.timeSlots?.map((slot) => (
                <th key={slot} className="text-center py-3 px-2 text-xs font-medium text-muted-foreground whitespace-nowrap">
                  {slot}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.departments?.map((dept) => (
              <tr key={dept?.name} className="border-b border-border">
                <td className="py-3 px-4 text-sm font-medium text-foreground">{dept?.name}</td>
                {dept?.utilization?.map((value, idx) => (
                  <td key={idx} className="py-2 px-2">
                    <div className={`${getUtilizationColor(value)} rounded px-2 py-1 text-center text-xs font-semibold transition-smooth`}>
                      {value}%
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center gap-4 mt-6 flex-wrap">
        <span className="text-xs font-medium text-muted-foreground">Utilization Level:</span>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-muted"></div>
          <span className="text-xs text-muted-foreground">Low (&lt;50%)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-success/70"></div>
          <span className="text-xs text-muted-foreground">Moderate (50-74%)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-warning"></div>
          <span className="text-xs text-muted-foreground">High (75-89%)</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 rounded bg-error"></div>
          <span className="text-xs text-muted-foreground">Critical (≥90%)</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceUtilizationHeatmap;